var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26003 5.86361L5.70183 9.06989C5.76016 9.12423 5.78933 9.1514 5.81867 9.16933C5.92815 9.23623 6.0663 9.23623 6.17578 9.16933C6.20513 9.1514 6.2343 9.12422 6.29262 9.06989L9.73443 5.86361C10.7028 4.96149 10.8204 3.47697 10.0059 2.43597L9.85281 2.24023C8.87848 0.9949 6.92276 1.20375 6.23815 2.62624C6.14144 2.82718 5.85302 2.82718 5.75631 2.62624C5.07169 1.20375 3.11597 0.9949 2.14165 2.24023L1.98851 2.43597C1.17405 3.47697 1.29165 4.96149 2.26003 5.86361Z",
    stroke: "#818291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.aaed00067171b64a6e331e6c850fc0e7.svg";
export { ForwardRef as ReactComponent };